<template>
    <div class="dd-m-menu__header dd-m-menu__header--logged" v-if="signed && user">
        <div class="dd-m-profile">
            <div class="dd-m-profile__photo">
                <img :srcset="user.image ? user.image : '/assets/site/images/perfil.png'"
                     :alt="user.name">
            </div>

            <div class="dd-m-profile__info dd-m-profile__info--default">
                <ul class="dd-m-profile__info__list">
                    <li class="dd-m-profile__info__item">
                        <span class="dd-m-profile__info__value">
                            {{user.messages}}
                        </span>
                        <span class="dd-m-profile__info__label">Mensagens</span>
                    </li>
                    <li class="dd-m-profile__info__item">
                        <span class="dd-m-profile__info__value">
                            {{user.quiz}}
                        </span>
                        <span class="dd-m-profile__info__label">Quiz</span>
                    </li>
                    <li class="dd-m-profile__info__item">
                        <span class="dd-m-profile__info__value">
                            {{user.ranking}}
                        </span>
                        <span class="dd-m-profile__info__label">Ranking</span>
                    </li>
                </ul>

                <a class="dd-m-button dd-m-button--light"
                   href="/minha-conta"
                   title="View Profile">
                    View Profile
                </a>
            </div>
        </div>
    </div>
</template>
<script>
    import UserService from '../../providers/api/user-service';
    import AuthService from '../../providers/api/auth-service';

    const api = new UserService(),
        authService = new AuthService();

    export default {
        name: 'profile-info',
        data: () => {
            return {
                signed: false,
                user: null
            }
        },
        mounted() {
            this.checkSign();
            this.subscribe();
        },
        methods: {
            subscribe() {
                PubSub.subscribe('updatedSign', () => this.checkSign());
            },
            isSignedIn() {
                return localStorage.token;
            },
            getUserInfo() {
                this.user = null;
                api.doGetInfo()
                    .then((res) => this.user = res.data.data)
                    .catch((err) => {
                        if (err.response.status === 401) {
                            authService.deleteCredentials();

                            setTimeout(() => {
                                PubSub.publish('updatedSign');
                            }, 200);
                        }
                    });
            },
            checkSign() {
                this.signed = this.isSignedIn();
                if (this.signed) {
                    this.getUserInfo();
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/site/js/components/header/profile-info.vue